import React from 'react'
import { styled, FloraVariants, forwardRef } from '@grupoboticario/flora-react-system'
import { HTMLFloraProps } from '@grupoboticario/flora-react-utils'

const StyledTableRoot = styled('table', {
  width: '100%',
  borderSpacing: '$space$0 $space$2',
  borderCollapse: 'separate',
  backgroundColor: '$backgroundSecondary',
  variants: {
    sticky: {
      true: {
        'tr:first-of-type': {
          top: 0,
          position: 'sticky',
          backgroundColor: '$backgroundSecondary',
          zIndex: 10,
        },
      },
    },
  },
})

export type TableRootProps = HTMLFloraProps<'table'> & FloraVariants<typeof StyledTableRoot>

export const TableRoot = forwardRef<'table', TableRootProps>((props, forwardedRef) => {
  return <StyledTableRoot ref={forwardedRef} data-flora="table-root" {...props} />
})
